import React, { Fragment } from 'react';
import Moment from 'react-moment';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import { capitalizeFirstLetter } from '../../helpers';

const styles = () => ({
  wrapper: {
    padding: 10,
    backgroundColor: '#fff',
    color: '#46606d',
    borderLeft: '8px solid #fff',
    borderBottom: '1px solid #ddd',
    paddingBottom: 40,
    paddingTop: 40,
    position: 'relative',
  },
  wrapperDetention: {
    backgroundColor: 'rgba(233, 30, 99, 0.08)',
    borderLeft: '8px solid #e91e63',
  },
  heading: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  content: {
    fontSize: 14,
    marginBottom: 10,
  },
  additional: {
    fontSize: 14,
    marginBottom: 10,
  },
  date: {
    fontSize: 14,
    marginBottom: 10,
    textAlign: 'right',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  noPaddingVertical: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  noPaddingLeft: {
    paddingLeft: '0 !important',
  },
  noPaddingRight: {
    paddingRight: '0 !important',
  },
  noPaddingHorizontal: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
  scoreBadge: {
    height: 28,
    width: 28,
    backgroundColor: '#666',
    borderRadius: 14,
    color: '#fff',
    textAlign: 'center',
    lineHeight: 2,
    fontSize: 14,
  },
  scoreBadgeQuestion: {
    backgroundColor: '#f9b233',
  },
  scoreBadgeNotice: {
    backgroundColor: '#7dbbee',
  },
  scoreBadgePositive: {
    backgroundColor: '#7ed75d',
  },
  scoreBadgeNegative: {
    backgroundColor: '#ff4a51',
  },
  scoreBadgeBlank: {
    backgroundColor: '#ffffff',
  },
  scoreBadgeDetention: {
    backgroundColor: '#ff4a51',
  },
  deleteWrapper: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    margin: 5,
    cursor: 'pointer',
  },
});

class ActivityEntry extends React.Component {
  render() {
    const {
      classes,
      t,
      data,
      onDelete,
      detentionAliasUc,
    } = this.props;

    const activityEntry = data;
    const finalType = activityEntry.polarity ? activityEntry.polarity : activityEntry.type;

    const scoreBadgeClassNameStyled = classes[`scoreBadge${capitalizeFirstLetter(finalType)}`];
    const scoreBadgeClassName = `${classes.scoreBadge} ${scoreBadgeClassNameStyled}`;

    const wrapperClassNameStyled = classes[`wrapper${capitalizeFirstLetter(activityEntry.type)}`];
    const wrapperClassName = `${classes.wrapper} ${wrapperClassNameStyled}`;

    const wrapperClassStyle = {};

    if (activityEntry.style.custom_class) {
      if (activityEntry.style.custom_class === 'notice-color') {
        wrapperClassStyle.borderColor = activityEntry.style.border_color;
      } else {
        const colour = activityEntry.style.custom_class.replace('colour-', '');
        wrapperClassStyle.borderLeftColor = colour === 'orange'
          ? '#f9b000'
          : colour === 'blue'
            ? '#2c9ed7'
            : colour === 'purple'
              ? '#8f2994'
              : '#7ed75d'; // green
        wrapperClassStyle.background = colour === 'orange'
          ? 'rgba(249, 176, 0, 0.08)'
          : colour === 'blue'
            ? 'rgba(44, 158, 215, 0.08)'
            : colour === 'purple'
              ? 'rgba(143, 41, 148, 0.08)'
              : 'rgba(126, 215, 93, 0.08)'; // green
      }
    }

    const headingText = activityEntry.pupil_name;
    let contentText = '';
    let additionalText = '';
    let scoreBadgeContent = '';

    if (activityEntry.type === 'detention') {
      if (!activityEntry.lesson_name) {
        if (activityEntry.teacher_name) {
          contentText = t('{detention_label} issued for {reason} by {teacher}')
            .replace('{detention_label}', detentionAliasUc)
            .replace('{reason}', `<b>${activityEntry.reason}</b>`)
            .replace('{teacher}', activityEntry.teacher_name);
        } else {
          contentText = t('{detention_label} issued for {reason}')
            .replace('{detention_label}', detentionAliasUc)
            .replace('{reason}', `<b>${activityEntry.reason}</b>`);
        }
      } else if (activityEntry.teacher_name) {
        contentText = t('{detention_label} issued for {reason} in {lesson} by {teacher}')
          .replace('{detention_label}', detentionAliasUc)
          .replace('{reason}', `<b>${activityEntry.reason}</b>`)
          .replace('{lesson}', activityEntry.lesson_name)
          .replace('{teacher}', activityEntry.teacher_name);
      } else {
        contentText = t('{detention_label} issued for {reason} in {lesson}')
          .replace('{detention_label}', detentionAliasUc)
          .replace('{reason}', `<b>${activityEntry.reason}</b>`)
          .replace('{lesson}', activityEntry.lesson_name);
      }

      if (activityEntry.room_name) {
        contentText += t(' in Room {room}').replace(
          '{room}',
          activityEntry.room_name,
        );
      }

      scoreBadgeContent = activityEntry.score > 0
        ? `+${activityEntry.score}`
        : activityEntry.score;
      additionalText = (
        <Fragment>
          {activityEntry.detention_location && (
            <span>
              <b>
                {t('Location')}
                {':'}
              </b>
              {' '}
              {activityEntry.detention_location}
              &nbsp;
            </span>
          )}
          {activityEntry.detention_type && (
            <span>
              <b>
                {t('Type')}
                {':'}
              </b>
              {' '}
              {activityEntry.detention_type}
              &nbsp;
            </span>
          )}
          {activityEntry.detention_date && (
            <span>
              <b>
                {t('Date')}
                {':'}
              </b>
              {' '}
              <Moment format={dateFormat}>{activityEntry.detention_date}</Moment>
              &nbsp;
            </span>
          )}
          {activityEntry.detention_time && (
            <span>
              <b>
                {t('Time')}
                {':'}
              </b>
              {' '}
              {activityEntry.detention_time}
              &nbsp;
            </span>
          )}
          {activityEntry.note && (
            <span>
              <b>
                {t('Note')}
                {':'}
              </b>
              {' '}
              {activityEntry.note}
            </span>
          )}
        </Fragment>
      );
    } else if (activityEntry.type === 'notice') {
      if (activityEntry.teacher_name) {
        contentText = t('{teacher} left a note.').replace(
          '{teacher}',
          activityEntry.teacher_name,
        );
      }
      additionalText = activityEntry.note;
      scoreBadgeContent = (
        <Fragment>
          <Edit style={{ fontSize: 12 }} />
        </Fragment>
      );
    } else if (activityEntry.type === 'event') {
      contentText = t('Intelligence event {name} occurred.').replace(
        '{name}',
        `<b>${activityEntry.reason}</b>`,
      );
    } else if (activityEntry.type === 'attendance_event') {
      // react-i18n doesn't like colons in strings, that's why it looks so strange
      contentText = activityEntry.parent_note
        ? t('Attendance event {name} occurred.').replace(
          '{name}',
          `<b>${activityEntry.reason}</b>`,
        ) + '<br />' + t('Note') + ': ' + activityEntry.parent_note
        : t('Attendance event {name} occurred.').replace(
          '{name}',
          `<b>${activityEntry.reason}</b>`,
        );
      if(activityEntry.badges) {
        contentText += '<br/>' + 'Badges awarded: ' + activityEntry.badges;
      }
    } else if (activityEntry.polarity) {
      if (!activityEntry.lesson_name) {
        if (!activityEntry.teacher_name) {
          contentText = t('{reason} awarded.').replace(
            '{reason}',
            `<b>${activityEntry.reason}</b>`,
          );
        } else {
          contentText = t('{reason} awarded by {teacher}.')
            .replace('{reason}', `<b>${activityEntry.reason}</b>`)
            .replace('{teacher}', activityEntry.teacher_name);
        }
      } else if (!activityEntry.teacher_name) {
        if (activityEntry.room_name) {
          contentText = t('{reason} awarded in {lesson} in Room {room}.')
            .replace('{reason}', `<b>${activityEntry.reason}</b>`)
            .replace('{lesson}', activityEntry.lesson_name)
            .replace('{room}', activityEntry.room_name);
        } else {
          contentText = t('{reason} awarded in {lesson}.')
            .replace('{reason}', `<b>${activityEntry.reason}</b>`)
            .replace('{lesson}', activityEntry.lesson_name);
        }
      } else if (activityEntry.room_name) {
        contentText = t(
          '{reason} awarded in {lesson} by {teacher} in Room {room}.',
        )
          .replace('{reason}', `<b>${activityEntry.reason}</b>`)
          .replace('{lesson}', activityEntry.lesson_name)
          .replace('{teacher}', activityEntry.teacher_name)
          .replace('{room}', activityEntry.room_name);
      } else {
        contentText = t('{reason} awarded by {teacher} in {lesson}.')
          .replace('{reason}', `<b>${activityEntry.reason}</b>`)
          .replace('{teacher}', activityEntry.teacher_name)
          .replace('{lesson}', activityEntry.lesson_name);
      }

      scoreBadgeContent = activityEntry.score > 0
        ? `+${activityEntry.score}`
        : activityEntry.score;
      additionalText = activityEntry.note;
    }

    return (
      <div
        className={`activity-entry ${wrapperClassName}`}
        style={wrapperClassStyle}
      >
        <Grid justify="space-between" container spacing={4} >
          <Grid item className={classes.noPaddingVertical}>
            <Grid justify="flex-start" container spacing={4} style={{'flexWrap': 'nowrap'}}>
              <Grid item>
                <div className={scoreBadgeClassName}>{scoreBadgeContent}</div>
              </Grid>
              <Grid item className={classes.noPaddingHorizontal}>
                <Typography
                  className={classes.heading}
                  variant="h6"
                  component="h6"
                >
                  {headingText}
                </Typography>
                <div
                  className={classes.content}
                  dangerouslySetInnerHTML={{
                    __html: contentText,
                  }}
                />
                {additionalText && (
                  <div className={classes.additional}>{additionalText}</div>
                )}
                {activityEntry._can_delete && (
                  <div
                    className={classes.deleteWrapper}
                    onClick={onDelete.bind(this, activityEntry)}
                  >
                    <Delete />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.date}>
            <Moment format="HH:mm">{activityEntry.timestamp}</Moment>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(ActivityEntry));
